import React, { useCallback, useState } from 'react';
import PageContainer from '../../components/Redesing/page-container';
import CardView from '../../components/Redesing/card-view';
import { useAddHardwareProduct } from '../../hooks/hardwareProduct/query/use-add-hardware-product';
import { Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import {
  MovaticFieldGroupCheck,
  MovaticFieldGroupText,
} from '../../components/Redesing/movatic-field-group';

import CustomToast from '../../components/Redesing/custom-toast';
import useAllHardwareProduct from '../../hooks/hardwareProduct/query/useAllHardwareProduct';

export interface FormState {
  [key: string]: string | boolean | null;
}

const AddProduct = () => {
  const [formState, setFormState] = useState<FormState>({});

  const {
    data: hardwareProduct,
    isLoading: hardwareProductLoading,
    refetch: refetchHardwareProduct,
  } = useAllHardwareProduct();

  const { mutateAsync: addProduct } = useAddHardwareProduct();

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, type, value, checked } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  }, []);

  const handleSave = async () => {
    try {
      const product = Object.entries(formState).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [key]: value === '' ? null : value,
        }),
        {}
      );

      await addProduct(product);
      refetchHardwareProduct();
    } catch (error) {
      CustomToast({
        message: 'Failed to add hardware product',
        type: 'error',
      });
    }
  };

  const content = () => {
    const fields = {
      checked: (props: any) => (
        <MovaticFieldGroupCheck
          key={props.dataIdInput}
          id={props.dataIdInput}
          label={props.label}
          description={props.description}
          name={props.name}
          onChange={handleChange}
          checked={props.checked}
        />
      ),
      text: (props: any) => (
        <MovaticFieldGroupText
          key={props.dataIdInput}
          id={props.dataIdInput}
          name={props.name}
          label={props.label}
          description={props.description}
          hasError={props.validationResult === 'error'}
          errorMessage={props.errorMessage}
          value={props.value}
          onChange={handleChange}
        />
      ),
    };

    return (
      <Stack px={2} pb={2}>
        {hardwareProduct?.map((field: any) => {
          const type = field.type === 'BOOL' ? 'checked' : 'text';
          const checked = field.type === 'BOOL' ? formState[field.name] : null;
          return fields[type]({
            ...field,
            label: field.name,
            checked,
            dataIdInput: `hardware-product-${field.name}`,
          });
        })}
      </Stack>
    );
  };

  return (
    <PageContainer isLoading={hardwareProductLoading}>
      <CardView
        title={'Add Hardware Product'}
        content={content()}
        headerActions={
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleSave}
            data-id="add-hardware-product-button"
          >
            Add
          </Button>
        }
        isLoading={false}
        dataId={'add-hardware-product'}
      />
    </PageContainer>
  );
};

export default AddProduct;
